if (!window.SubscriptionFunnel) {
  window.SubscriptionFunnel = {};
}

window.SubscriptionFunnel.CondensedQuizDataReady = false;
window.SubscriptionFunnel.StepCondensed = {
  isCondensedAffiliateTest() {
    return (
      window.SubscriptionFunnel?.FunnelUtilities?.funnel_test ===
      "condensed-affiliate"
    );
  },

  isCondensedMode() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return (
      urlSearchParams.get("funnel-condensed") === "true" ||
      this.isCondensedAffiliateTest()
    );
  },

  isEmailCaptureRequired() {
    const emailSection = document.getElementById("condensed-email-section");
    return Boolean(
      emailSection && !emailSection.classList.contains("display-none")
    );
  },

  updateEmailSectionVisibility() {
    const emailSection = document.getElementById("condensed-email-section");
    if (!emailSection) return;

    const alwaysShowEmail = this.isCondensedAffiliateTest();
    const hasEmail = Boolean(quizData?.email?.trim());
    emailSection.classList.toggle("display-none", !alwaysShowEmail && hasEmail);
    this.validationConfig = this.getValidationConfig();
  },

  init() {
    this.form = document.getElementById("condensed-form");
    if (!this.form) return;

    this.startOverButton = document.getElementById(
      "condensed-start-over"
    );
    this.checkoutButton = document.getElementById("condensed-checkout");
    this.allergySpecificFields = ["allergiesChicken", "allergiesTurkey", "allergiesBeef"];
    this.breedTypeaheadConfigs = [
      this.createBreedConfig("condensed-breed1"),
      this.createBreedConfig("condensed-breed2"),
    ];
    this.gwpHiddenInput = this.form.querySelector("#condensed-gwp-variant");
    this.gwpVariants = window.SubscriptionFunnel?.condensedGwpData?.variants || [];
    this.gwpOptions = window.SubscriptionFunnel?.condensedGwpData?.options || [];

    this.bindEvents();
    this.initEmailInputValidation();
    this.syncFormFromQuizData();
    this.updateEmailSectionVisibility();
    if (document.getElementById("condensed-breed1")) {
      this.initBreedTypeahead();
    }
    this.initGwpOptionListeners();
    this.initializeGwpState();
    this.updatePrepaidSectionVisibility();
    this.initCondensedAffiliateProductLine();

    if (window.SubscriptionFunnel.CondensedQuizDataReady) {
      this.syncFormFromQuizData();
      this.updatePrepaidSectionVisibility();
      this.updateEmailSectionVisibility();
      this.initCondensedAffiliateProductLine();
      this.initializeGwpState();
    }
  },

  initCondensedAffiliateProductLine() {
    if (!this.isCondensedAffiliateTest()) return;
    window.SubscriptionFunnel.CondensedProductLine?.init?.();
  },

  bindEvents() {
    if (this.form) {
      this.form.addEventListener("input", (event) => {
        this.handleInputChange(event);
      });
      this.form.addEventListener("change", (event) => {
        this.handleInputChange(event);
      });
      this.form.addEventListener("submit", (event) => {
        event.preventDefault();
        this.handleCheckout();
      });
    }

    if (this.startOverButton) {
      this.startOverButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleStartOver();
      });
    }
  },

  syncFormFromQuizData() {
    if (!quizData) return;

    this.setTextInputValue('input[data-quiz-key="dogName"]', quizData.dogName);
    this.setTextInputValue('input[data-quiz-key="dogBirthday"]', quizData.dogBirthday);
    this.setTextInputValue('input[data-quiz-key="breed1"]', quizData.breed1);
    this.setTextInputValue('input[data-quiz-key="breed2"]', quizData.breed2);
    this.setTextInputValue('input[data-quiz-key="email"]', quizData.email);
    this.setCheckboxValue(
      "marketingConsent",
      quizData.marketingConsent !== false && quizData.marketingConsent !== "false"
    );

    this.setRadioValue("dogSize", quizData.dogSize);
    this.setRadioValue("dogGender", quizData.dogGender);
    this.setRadioValue("commitmentLength", quizData.commitmentLength);
    this.setRadioValue("extraToy", this.booleanToString(quizData.extraToy));
    this.allergySpecificFields.forEach((field) => {
      this.setCheckboxValue(field, quizData[field]);
    });
    this.syncAllergyNoneCheckbox();
    this.syncGwpFromQuizData();
    
    // Handle prepaid sync and visibility
    if (quizData.commitmentLength) {
      this.handleCommitmentLengthChange(quizData.commitmentLength);
    }
    if (quizData.prepaid !== undefined) {
      this.setRadioValue("prepaid", this.booleanToString(quizData.prepaid));
    }

    if (quizData.dogName) {
      document
        .querySelectorAll("#condensed-email-section [data-dog-name]")
        .forEach((el) => {
          el.textContent = quizData.dogName;
        });
    }

    if (this.isCondensedAffiliateTest()) {
      window.SubscriptionFunnel.CondensedProductLine?.syncFromQuizData?.();
    }
  },

  setTextInputValue(selector, value) {
    if (!value || !this.form) return;
    const input = this.form.querySelector(selector);

    if (input && input.value !== value) {
      input.value = value;
    }
  },

  setRadioValue(name, value) {
    if (!value || !this.form) return;
    const radio = this.form.querySelector(
      `input[data-quiz-key="${name}"][value="${value}"]`
    );
    if (radio && !radio.checked) {
      radio.checked = true;
    }
  },

  setCheckboxValue(name, value) {
    if (!this.form) return;
    const checkbox = this.form.querySelector(`input[data-quiz-key="${name}"]`);
    if (!checkbox) return;
    checkbox.checked = this.toBoolean(value);
  },

  initEmailInputValidation() {
    const emailInput = document.getElementById("condensed-email");
    const errorElement = document.getElementById("condensed-email-error");

    if (
      emailInput &&
      errorElement &&
      window.SubscriptionFunnel?.StepEmail?.handleEmailInput
    ) {
      SubscriptionFunnel.StepEmail.handleEmailInput(emailInput, errorElement);
    }
  },

  handleInputChange(event) {
    const target = event.target;
    if (!target) return;
    const quizKey = target.dataset.quizKey || target.name;
    if (!quizKey && !target.dataset.condensedAllergy) return;

    if (target.dataset.condensedBreedClear) {
      return;
    }

    if (target.dataset.condensedAllergy === "none") {
      this.handleAllergyNoneChange(target);
      return;
    }

    if (target.dataset.condensedAllergy === "specific") {
      this.handleSpecificAllergyChange(target);
      return;
    }

    if (target.type === "radio") {
      if (target.checked) {
        if (target.name && target.name.startsWith("summary-")) {
          this.handleGwpOptionChange();
        } else if (quizKey === "productLine") {
          window.SubscriptionFunnel.CondensedProductLine?.handleProductLineChange?.(
            target.value
          );
        } else {
          quizData[quizKey] = target.value;
          
          // Handle commitment length changes
          if (quizKey === "commitmentLength") {
            this.handleCommitmentLengthChange(target.value);
          }
          
          // Handle prepaid changes
          if (quizKey === "prepaid") {
            quizData.prepaid = target.value === "true";
          }
          
          // Update prepaid price if extra toy selection changes
          if (quizKey === "extraToy") {
            const commitmentLength = Number(quizData.commitmentLength);
            if (commitmentLength === 6 || commitmentLength === 12) {
              this.updatePrepaidPrice();
            }
          }
        }
      }
      return;
    }

    if (target.type === "checkbox") {
      quizData[quizKey] = target.checked;
      return;
    }

    if (quizKey) {
      quizData[quizKey] = target.value;
      if (quizKey === "dogName") {
        document
          .querySelectorAll("#condensed-email-section [data-dog-name]")
          .forEach((el) => {
            el.textContent = target.value.trim() || "your pup";
          });
      }
      if (quizKey === "gwp") {
        this.updateGwpPromoValueByVariantId(target.value);
      }
    }
  },

  handleStartOver() {
    const utilities = window.SubscriptionFunnel?.FunnelUtilities;
    if (utilities?.resetFunnel) {
      utilities.resetFunnel();
    } else {
      window.location.reload();
    }
  },

  handleCheckout() {
    if (!this.form) return;
    this.clearValidationErrors();
    const validationResult = this.validateForm();
    if (!validationResult.isValid) {
      this.renderValidationErrors(validationResult.errors);
      return;
    }
    
    // Disable button and show loader
    if (this.checkoutButton) {
      this.checkoutButton.disabled = true;
      this.checkoutButton.dataset.checkoutLoading = "true";
      const buttonText = this.checkoutButton.querySelector(".button-text");
      const loader = this.checkoutButton.querySelector(".loader");
      if (buttonText) {
        buttonText.classList.add("display-none");
      }
      if (loader) {
        loader.classList.remove("display-none");
      }
    }
    
    this.syncQuizDataFromForm();
    this.updateAllergyQuizDataFromForm();
    
    // Ensure prepaid is false for 1 month plans
    if (Number(quizData.commitmentLength) === 1) {
      quizData.prepaid = false;
    }

    if (typeof completeQuiz === "function") {
      completeQuiz(this.getCondensedPromoSource());
    }
  },

  getCondensedPromoSource() {
    if (this.isCondensedAffiliateTest()) {
      return SubscriptionFunnel.FunnelUtilities.funnel_test || "condensed-affiliate";
    }

    return "Re-targeting Funnel";
  },

  booleanToString(value) {
    if (value === true || value === "true") return "true";
    if (value === false || value === "false") return "false";
    return "";
  },

  toBoolean(value) {
    return value === true || value === "true" || value === 1 || value === "1";
  },

  createBreedConfig(baseId) {
    return {
      inputId: baseId,
      listId: `${baseId}-matches`,
      clearSelector: `[data-condensed-breed-clear="${baseId}"]`,
    };
  },

  initBreedTypeahead() {
    const breedList = this.getBreedList();
    if (!breedList.length) return;

    this.breedTypeaheadConfigs.forEach((config) => {
      const input = document.getElementById(config.inputId);
      const matchList = document.getElementById(config.listId);
      const clearButton = document.querySelector(config.clearSelector);
      if (!input || !matchList) return;

      input.addEventListener("input", (event) => {
        this.handleBreedSuggestions(event.target, matchList, clearButton);
      });

      input.addEventListener("focus", (event) => {
        this.handleBreedSuggestions(event.target, matchList, clearButton);
      });

      if (clearButton) {
        clearButton.addEventListener("click", () => {
          input.value = "";
          matchList.innerHTML = "";
          matchList.style.display = "none";
          clearButton.classList.add("display-none");
          const key = input.dataset.quizKey || input.name;
          if (key) {
            quizData[key] = "";
          }
        });
      }
    });

    document.addEventListener("click", (event) => {
      this.breedTypeaheadConfigs.forEach((config) => {
        const matchList = document.getElementById(config.listId);
        const input = document.getElementById(config.inputId);
        if (!matchList || !input) return;
        if (
          matchList !== event.target &&
          !matchList.contains(event.target) &&
          input !== event.target
        ) {
          matchList.style.display = "none";
        }
      });
    });
  },

  getBreedList() {
    return (
      window.SubscriptionFunnel?.StepBreed?.DOG_BREEDS ||
      window.SubscriptionFunnel?.StepBreed?.dogBreeds ||
      []
    );
  },

  handleBreedSuggestions(input, matchList, clearButton) {
    if (!matchList) return;
    const breeds = this.getBreedList();
    const value = input.value.trim();

    if (clearButton) {
      clearButton.classList.toggle("display-none", value.length === 0);
    }

    if (!value) {
      matchList.innerHTML = "";
      matchList.style.display = "none";
      return;
    }

    let filteredBreeds = breeds.filter((breed) =>
      breed.toLowerCase().includes(value.toLowerCase())
    );

    if (filteredBreeds.length === 0) {
      filteredBreeds = ["Don't see my dog's breed"];
    }

    matchList.innerHTML = "";
    filteredBreeds.slice(0, 6).forEach((breed) => {
      const li = document.createElement("li");
      li.textContent = breed;
      li.tabIndex = "-1";
      li.setAttribute("aria-selected", "false");
      li.setAttribute("role", "option");
      li.addEventListener("click", () => {
        if (breed !== "Don't see my dog's breed") {
          input.value = breed;
          const key = input.dataset.quizKey || input.name;
          if (key) {
            quizData[key] = breed;
          }
        }
        matchList.style.display = "none";
        input.dispatchEvent(new Event("input", { bubbles: true }));
      });
      matchList.appendChild(li);
    });

    matchList.style.display = "block";
  },

  syncAllergyNoneCheckbox() {
    if (!this.form) return;
    const noneCheckbox = this.form.querySelector("#condensed-allergy-none");
    if (!noneCheckbox) return;
    const hasSpecific = this.allergySpecificFields.some((field) =>
      this.isCheckboxChecked(field)
    );
    const hasAllergies = this.toBoolean(quizData.allergies);
    noneCheckbox.checked = !hasAllergies && !hasSpecific;
  },

  handleAllergyNoneChange(target) {
    if (target.checked) {
      this.allergySpecificFields.forEach((field) => {
        const checkbox = document.querySelector(`input[data-quiz-key="${field}"]`);
        if (checkbox) {
          checkbox.checked = false;
        }
        quizData[field] = false;
      });
      quizData.allergies = false;
    }
  },

  handleSpecificAllergyChange(target) {
    const key = target.dataset.quizKey || target.name;
    if (key) {
      quizData[key] = target.checked;
    }
    if (target.checked) {
      quizData.allergies = true;
      this.setAllergyNone(false);
      return;
    }

    const hasAny = this.allergySpecificFields.some((field) =>
      this.isCheckboxChecked(field)
    );
    quizData.allergies = hasAny;
    if (!hasAny) {
      this.setAllergyNone(true);
    }
  },

  setAllergyNone(shouldCheck) {
    const noneCheckbox = this.form?.querySelector("#condensed-allergy-none");
    if (!noneCheckbox) return;
    noneCheckbox.checked = shouldCheck;
    if (shouldCheck) {
      quizData.allergies = false;
    }
  },

  updateAllergyQuizDataFromForm() {
    this.allergySpecificFields.forEach((field) => {
      quizData[field] = this.isCheckboxChecked(field);
    });

    const hasSpecific = this.allergySpecificFields.some(
      (field) => quizData[field] === true
    );
    const allergyNone = this.form?.querySelector("#condensed-allergy-none");
    if (allergyNone?.checked) {
      quizData.allergies = false;
    } else {
      quizData.allergies = hasSpecific;
    }
  },

  isCheckboxChecked(name) {
    if (!this.form) return false;
    const checkbox = this.form.querySelector(`input[data-quiz-key="${name}"]`);
    return checkbox ? checkbox.checked : false;
  },

  getGwpInputName(option) {
    const name = typeof option === "string" ? option : option.name;
    return `summary-${name.replace(/\s+/g, "-").toLowerCase()}`;
  },

  getFunnelSoldOutOverrideVariantIds() {
    return (window.variantpromoValueData || [])
      .filter((variant) => variant.funnelSoldOutOverride)
      .map((variant) => Number(variant.variantId));
  },

  getHiddenGwpVariantIds() {
    return (window.hiddenVariants || []).map((id) => Number(id));
  },

  isGwpVariantSelectable(variant) {
    if (!variant) return false;

    const variantId = Number(variant.id);
    if (this.getHiddenGwpVariantIds().includes(variantId)) {
      return false;
    }
    if (this.getFunnelSoldOutOverrideVariantIds().includes(variantId)) {
      return false;
    }

    return Boolean(variant.available);
  },

  isGwpVariantAvailable(variantId) {
    const variant = this.gwpVariants.find(
      (entry) => Number(entry.id) === Number(variantId)
    );
    return this.isGwpVariantSelectable(variant);
  },

  getGwpSelections() {
    const selections = [];

    this.gwpOptions.forEach((option) => {
      if (option.name === "Title") return;

      const selected = this.form.querySelector(
        `input[name="${this.getGwpInputName(option)}"]:checked:not(:disabled)`
      );
      if (selected) {
        selections.push(selected.value);
      }
    });

    return selections;
  },

  getMatchingGwpVariant(selections = this.getGwpSelections()) {
    return (
      this.gwpVariants.find((variant) =>
        variant.options.every((option) => selections.includes(option))
      ) || null
    );
  },

  handleGwpOptionChange() {
    this.updateGwpDisableSelectors();
    this.updateGwpVariantFromSelections();
  },

  initializeGwpState() {
    if (!this.form || !this.gwpHiddenInput || !this.gwpOptions.length) return;

    const hasValidQuizGwp =
      quizData.gwp && this.isGwpVariantAvailable(quizData.gwp);

    if (!hasValidQuizGwp) {
      this.selectFirstAvailableGwpVariant();
    }

    this.updateGwpDisableSelectors();
    this.updateGwpVariantFromSelections();
  },

  selectFirstAvailableGwpVariant() {
    if (!this.form || !this.gwpVariants.length) return;

    const selectableVariant = this.gwpVariants.find((variant) =>
      this.isGwpVariantSelectable(variant)
    );
    if (!selectableVariant) return;

    this.gwpOptions.forEach((option, optionIndex) => {
      if (option.name === "Title") return;

      const optionValue = selectableVariant.options[optionIndex];
      if (!optionValue) return;

      const radio = this.form.querySelector(
        `input[name="${this.getGwpInputName(option)}"][value="${optionValue}"]`
      );
      if (radio) {
        radio.checked = true;
      }
    });
  },

  updateGwpDisableSelectors() {
    if (!this.form || !this.gwpOptions.length || !this.gwpVariants.length) return;

    const options = this.gwpOptions;
    const variants = this.gwpVariants;
    const funnelSoldOutOverrideVariantIds = this.getFunnelSoldOutOverrideVariantIds();
    const hiddenVariantIds = this.getHiddenGwpVariantIds();

    if (variants.length === 1) {
      const variant = variants[0];
      const gwpImage = this.form.querySelector(".condensed-gwp-image img");
      if (gwpImage && variant.featured_image?.src) {
        gwpImage.src = variant.featured_image.src;
      }
      this.updateGwpCheckoutState();
      return;
    }

    const selections = this.getGwpSelections();
    const matchingVariant =
      this.getMatchingGwpVariant(selections) ||
      variants.find((variant) => this.isGwpVariantSelectable(variant)) ||
      variants[0];

    const gwpImage = this.form.querySelector(".condensed-gwp-image img");
    if (gwpImage && matchingVariant?.featured_image?.src) {
      gwpImage.src = matchingVariant.featured_image.src;
    }

    this.updateGwpCheckoutState();

    if (!options[0]) return;

    options[0].values.forEach((value) => {
      const hasAvailableVariant = variants.some(
        (variant) =>
          variant.option1 === value &&
          !funnelSoldOutOverrideVariantIds.includes(Number(variant.id)) &&
          variant.available
      );

      const hiddenVariant = variants.some(
        (variant) =>
          variant.option1 === value &&
          (options[1] ? variant.option2 === matchingVariant.option2 : true) &&
          (options[2] ? variant.option3 === matchingVariant.option3 : true) &&
          hiddenVariantIds.includes(Number(variant.id))
      );

      const input1 =
        options[0].name === "Title"
          ? null
          : this.form.querySelector(
              `input[name="${this.getGwpInputName(options[0])}"][value="${value}"]`
            );
      if (!input1) return;

      input1.disabled = !hasAvailableVariant;
      input1.hidden = hiddenVariant;
      if (hiddenVariant) {
        input1.checked = false;
      }

      if (options[1]) {
        options[1].values.forEach((value2) => {
          const hasAvailableVariant2 = variants.some(
            (variant) =>
              variant.option2 === value2 &&
              variant.option1 === matchingVariant.option1 &&
              !funnelSoldOutOverrideVariantIds.includes(Number(variant.id)) &&
              variant.available
          );

          const hiddenVariant2 = variants.some(
            (variant) =>
              variant.option2 === value2 &&
              variant.option1 === matchingVariant.option1 &&
              (options[2] ? variant.option3 === matchingVariant.option3 : true) &&
              hiddenVariantIds.includes(Number(variant.id))
          );

          const input2 =
            options[1].name === "Title"
              ? null
              : this.form.querySelector(
                  `input[name="${this.getGwpInputName(options[1])}"][value="${value2}"]`
                );
          if (!input2) return;

          input2.disabled = !hasAvailableVariant2;
          input2.hidden = hiddenVariant2;
          if (hiddenVariant2) {
            input2.checked = false;
          }
        });
      }

      if (options[2]) {
        options[2].values.forEach((value3) => {
          const hasAvailableVariant3 = variants.some(
            (variant) =>
              variant.option3 === value3 &&
              variant.option1 === matchingVariant.option1 &&
              variant.option2 === matchingVariant.option2 &&
              !funnelSoldOutOverrideVariantIds.includes(Number(variant.id)) &&
              variant.available
          );

          const hiddenVariant3 = variants.some(
            (variant) =>
              variant.option3 === value3 &&
              variant.option1 === matchingVariant.option1 &&
              variant.option2 === matchingVariant.option2 &&
              hiddenVariantIds.includes(Number(variant.id))
          );

          const input3 =
            options[2].name === "Title"
              ? null
              : this.form.querySelector(
                  `input[name="${this.getGwpInputName(options[2])}"][value="${value3}"]`
                );
          if (!input3) return;

          input3.disabled = !hasAvailableVariant3;
          input3.hidden = hiddenVariant3;
          if (hiddenVariant3) {
            input3.checked = false;
          }
        });
      }
    });
  },

  updateGwpCheckoutState() {
    if (!this.checkoutButton || !this.gwpHiddenInput) return;
    if (this.checkoutButton.dataset.checkoutLoading === "true") return;

    if (this.gwpVariants.length === 1) {
      this.checkoutButton.disabled = !this.isGwpVariantSelectable(
        this.gwpVariants[0]
      );
      return;
    }

    const variantId = this.gwpHiddenInput.value;
    if (!variantId) return;

    this.checkoutButton.disabled = !this.isGwpVariantAvailable(variantId);
  },

  updateGwpVariantFromSelections() {
    if (!this.form || !this.gwpOptions.length) return;

    if (this.gwpVariants.length === 1) {
      const variant = this.gwpVariants[0];
      if (this.isGwpVariantSelectable(variant)) {
        this.setGwpVariant(variant.id, variant);
      } else {
        this.setGwpVariant(null);
      }
      this.updateGwpCheckoutState();
      return;
    }

    const selections = this.getGwpSelections();

    if (selections.length === 0) {
      this.setGwpVariant(null);
      this.updateGwpCheckoutState();
      return;
    }

    const matchingVariant = this.getMatchingGwpVariant(selections);

    if (matchingVariant && this.isGwpVariantSelectable(matchingVariant)) {
      this.setGwpVariant(matchingVariant.id, matchingVariant);
    } else {
      this.setGwpVariant(null);
    }

    this.updateGwpCheckoutState();
  },

  setGwpVariant(variantId, variant = null) {
    if (this.gwpHiddenInput) {
      this.gwpHiddenInput.value = variantId || "";
    }
    quizData.gwp = variantId || "";
    
    // Update image if variant provided
    if (variant && variant.featured_image) {
      const condensedStep = document.getElementById('funnel-step-condensed');
      const gwpImage = condensedStep?.querySelector('.condensed-gwp-image img');
      if (gwpImage) {
        gwpImage.src = variant.featured_image.src;
      }
    }
    
    if (variantId && window.variantpromoValueData) {
      const variantIdNumber = Number(variantId);
      const promoMatch = window.variantpromoValueData.find(
        (entry) => Number(entry.variantId) === variantIdNumber
      );
      if (promoMatch?.variantPromoValue) {
        quizData.gwpVariantPromoValue = promoMatch.variantPromoValue;
      }
    }
  },

  syncGwpFromQuizData() {
    if (!this.form || !quizData.gwp || !this.gwpVariants.length) return;
    
    const variant = this.gwpVariants.find(
      (v) => Number(v.id) === Number(quizData.gwp)
    );
    if (!variant) return;

    this.gwpOptions.forEach((option, optionIndex) => {
      if (option.name === "Title") return;
      const optionValue = variant.options[optionIndex];
      if (!optionValue) return;
      
      const optionName = `summary-${option.name.replace(/\s+/g, "-").toLowerCase()}`;
      const radio = this.form.querySelector(
        `input[name="${optionName}"][value="${optionValue}"]`
      );
      if (radio) {
        radio.checked = true;
      }
    });

    this.setGwpVariant(variant.id, variant);
  },

  syncQuizDataFromForm() {
    if (!this.form) return;
    const fields = this.form.querySelectorAll("[data-quiz-key]");
    fields.forEach((field) => {
      const key = field.dataset.quizKey;
      if (!key) return;

      if (field.type === "radio") {
        if (field.checked && field.name && !field.name.startsWith("summary-")) {
          // Convert prepaid to boolean instead of string
          if (key === "prepaid") {
            quizData[key] = field.value === "true";
          } else {
            quizData[key] = field.value;
          }
        }
        return;
      }

      if (field.type === "checkbox") {
        quizData[key] = field.checked;
        return;
      }

      quizData[key] = field.value.trim();
    });
    
    // Sync GWP variant from selections
    if (this.gwpHiddenInput) {
      this.updateGwpVariantFromSelections();
    }
  },

  getValidationConfig() {
    const config = [];

    if (document.getElementById("condensed-product-line-section")) {
      config.push({
        field: "productLine",
        selector: 'input[data-quiz-key="productLine"]',
        type: "radio",
        validate: () =>
          !!document.querySelector('input[data-quiz-key="productLine"]:checked'),
        message: "Please select a product line.",
      });
    }

    config.push(
      {
        field: "dogName",
        selector: '#condensed-dog-name',
        validate: (value) => value.trim().length > 0,
        message: "Please tell us your pup's name."
      },
      {
        field: "dogGender",
        selector: 'input[data-quiz-key="dogGender"]',
        type: "radio",
        validate: () => !!document.querySelector('input[data-quiz-key="dogGender"]:checked'),
        message: "Please select a gender."
      },
      {
        field: "dogSize",
        selector: 'input[data-quiz-key="dogSize"]',
        type: "radio",
        validate: () => !!document.querySelector('input[data-quiz-key="dogSize"]:checked'),
        message: "Please select a size."
      },
      {
        field: "allergies",
        selector: '[data-condensed-allergy]',
        type: "checkbox-group",
        validate: () => {
          const hasSpecific = this.allergySpecificFields.some((field) =>
            this.isCheckboxChecked(field)
          );
          const noneChecked = document.getElementById("condensed-allergy-none")?.checked;
          return hasSpecific || noneChecked;
        },
        message: "Please let us know if your pup has allergies."
      },
      {
        field: "commitmentLength",
        selector: 'input[data-quiz-key="commitmentLength"]',
        type: "radio",
        validate: () => !!document.querySelector('input[data-quiz-key="commitmentLength"]:checked'),
        message: "Please choose a plan length."
      }
    );

    if (this.form?.querySelector("#condensed-breed1")) {
      config.push({
        field: "breed1",
        selector: "#condensed-breed1",
        optional: true,
        validate: (value) => {
          if (!value.trim()) return true;
          const breeds = this.getBreedList();
          return breeds.includes(value.trim());
        },
        message: "Please pick a primary breed from our list.",
      });
    }

    if (this.form && this.form.querySelector('[data-summary-field="extraToy"]')) {
      config.push({
        field: "extraToy",
        selector: 'input[data-quiz-key="extraToy"]',
        type: "radio",
        validate: () => !!document.querySelector('input[data-quiz-key="extraToy"]:checked'),
        message: "Let us know if you want the extra toy."
      });
    }

    if (this.gwpHiddenInput) {
      config.push({
        field: "gwp",
        selector: '#condensed-gwp-variant',
        validate: () => {
          const variantId = document.getElementById("condensed-gwp-variant")?.value;
          return Boolean(variantId) && this.isGwpVariantAvailable(variantId);
        },
        message: "Please choose an available gift option."
      });
    }

    if (this.isEmailCaptureRequired()) {
      config.push({
        field: "email",
        selector: "#condensed-email",
        validate: (value) => this.validateEmailValue(value),
        message: "Error: Valid email address required.",
      });
    }

    return config;
  },

  validateEmailValue(value) {
    if (!this.isEmailCaptureRequired()) {
      return true;
    }

    const trimmed = (value || "").trim();
    if (!trimmed) {
      return false;
    }

    return SubscriptionFunnel.StepEmail?.validateEmail(trimmed) ?? false;
  },

  initGwpOptionListeners() {
    if (!this.form) return;
    const gwpRadios = this.form.querySelectorAll('input[name^="summary-"]');
    if (!gwpRadios.length) return;

    gwpRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.handleGwpOptionChange();
      });
    });
  },

  clearValidationErrors() {
    this.form.querySelectorAll(".condensed-error").forEach((el) => {
      el.textContent = "";
      el.classList.add("display-none");
    });

    const emailError = document.getElementById("condensed-email-error");
    if (emailError) {
      emailError.textContent = "";
      emailError.classList.add("display-none");
    }

    this.form.querySelectorAll(".text-input-component-input--error").forEach((el) => {
      el.classList.remove("text-input-component-input--error");
    });

    this.form
      .querySelectorAll(".radio-decoy-component--error")
      .forEach((el) => el.classList.remove("radio-decoy-component--error"));
    this.form
      .querySelectorAll(".condensed-field-group--error")
      .forEach((el) => el.classList.remove("condensed-field-group--error"));
    this.form
      .querySelectorAll(".product-line-card.card--error")
      .forEach((el) => el.classList.remove("card--error"));
  },

  validateForm() {
    const result = { isValid: true, errors: [] };

    this.validationConfig.forEach((rule) => {
      const input = document.querySelector(rule.selector);

      let value = "";
      if (rule.type === "radio") {
        const selected = document.querySelector(`${rule.selector}:checked`);
        value = selected ? selected.value : "";
      } else if (input) {
        value = input.value;
      }

      let isValid = rule.optional ? true : rule.validate(value);
      let message = rule.message;

      if (rule.field === "email" && !isValid) {
        message = (value || "").trim()
          ? "Error: Valid email address required."
          : "Error: Required field.";
      }

      if (!isValid) {
        result.isValid = false;
        result.errors.push({ rule, input, message });
      }
    });

    return result;
  },

  renderValidationErrors(errors) {
    errors.forEach(({ rule, input, message }) => {
      const fieldWrapper = this.form.querySelector(
        `[data-summary-field="${rule.field}"]`
      );
      const placeholder = fieldWrapper?.querySelector(
        `[data-summary-error-for="${rule.field}"]`
      );

      if (rule.type === "radio" || rule.type === "checkbox-group") {
        const radioGroup = fieldWrapper?.querySelector(".radio-decoy-component");
        if (radioGroup) {
          radioGroup.classList.add("radio-decoy-component--error");
        } else if (rule.field === "productLine") {
          fieldWrapper
            ?.querySelectorAll(".product-line-card")
            .forEach((card) => card.classList.add("card--error"));
        } else {
          fieldWrapper?.classList.add("condensed-field-group--error");
        }
      } else if (input) {
        input.classList.add("text-input-component-input--error");
      }

      const errorMessage = message || rule.message;

      if (rule.field === "email") {
        const emailError = document.getElementById("condensed-email-error");
        if (emailError) {
          emailError.textContent = errorMessage;
          emailError.classList.remove("display-none");
        }
      }

      if (placeholder) {
        placeholder.textContent = errorMessage;
        placeholder.classList.remove("display-none");
      } else if (fieldWrapper && rule.field !== "email") {
        const error = document.createElement("p");
        error.className = "condensed-error";
        error.textContent = errorMessage;
        fieldWrapper.appendChild(error);
      }
    });
  },

  updatePrepaidSectionVisibility() {
    const commitmentLength = Number(quizData.commitmentLength);
    // If no commitment length selected, pass undefined/null to show disabled state
    this.handleCommitmentLengthChange(commitmentLength || null);
  },

  handleCommitmentLengthChange(commitmentLength) {
    const commitmentNum = commitmentLength ? Number(commitmentLength) : null;
    const prepaidSection = document.getElementById("condensed-prepaid-section");
    const prepaidYesRadio = this.form?.querySelector("#condensed-prepaid-yes");
    const prepaidNoRadio = this.form?.querySelector("#condensed-prepaid-no");
    const prepaidPriceText = document.querySelector("[data-condensed-prepaid-text]");
    const prepaidPriceElement = document.querySelector("[data-condensed-prepaid-price]");
    
    if (!prepaidSection) return;
    
    // Show prepaid section only for 6 or 12 month plans
    if (commitmentNum === 6 || commitmentNum === 12) {
      prepaidSection.classList.remove("display-none");
      // Enable the radio buttons
      if (prepaidYesRadio) {
        prepaidYesRadio.disabled = false;
      }
      if (prepaidNoRadio) {
        prepaidNoRadio.disabled = false;
      }
      // Show price text and update price
      if (prepaidPriceText) {
        prepaidPriceText.classList.remove("display-none");
      }
      if (prepaidPriceElement) {
        prepaidPriceElement.classList.remove("display-none");
      }
      this.updatePrepaidPrice();
    } else {
      // Hide prepaid section for 1 month plans or when no commitment length is selected
      prepaidSection.classList.add("display-none");
      // Set prepaid to false for 1 month plans
      if (commitmentNum === 1) {
        quizData.prepaid = false;
      }
      if (prepaidNoRadio) {
        prepaidNoRadio.checked = true;
        prepaidNoRadio.disabled = true;
      }
      if (prepaidYesRadio) {
        prepaidYesRadio.checked = false;
        prepaidYesRadio.disabled = true;
      }
      // Hide price text
      if (prepaidPriceText) {
        prepaidPriceText.classList.add("display-none");
      }
      if (prepaidPriceElement) {
        prepaidPriceElement.classList.add("display-none");
      }
    }
  },

  updatePrepaidPrice() {
    const commitmentLength = Number(quizData.commitmentLength);
    
    // Only calculate for 6 or 12 month plans
    if (commitmentLength !== 6 && commitmentLength !== 12) {
      return;
    }

    // Get the monthly price from the selected commitment length radio button
    const selectedRadio = this.form?.querySelector(
      `input[data-quiz-key="commitmentLength"][value="${commitmentLength}"]`
    );
    
    if (!selectedRadio) {
      return;
    }

    const monthlyPriceCents = Number(selectedRadio.dataset.monthlyPrice);
    if (!monthlyPriceCents || isNaN(monthlyPriceCents)) {
      return;
    }

    // Check if extra toy is selected
    const hasExtraToy = quizData.extraToy === "true" || quizData.extraToy === true;
    const extraToyPricePerMonth = 9; // $9 per month for extra toy club

    // Calculate prepaid price:
    // Base monthly price * commitment length + (extra toy price * commitment length if selected)
    // Then apply 10% discount (multiply by 0.9)
    // Price is in cents, so convert to dollars
    const monthlyPriceDollars = monthlyPriceCents / 100;
    const monthlyTotal = monthlyPriceDollars + (hasExtraToy ? extraToyPricePerMonth : 0);
    const baseTotal = monthlyPriceDollars * commitmentLength;
    const extraToyTotal = hasExtraToy ? extraToyPricePerMonth * commitmentLength : 0;
    const totalBeforeDiscount = baseTotal + extraToyTotal;
    const prepaidPrice = totalBeforeDiscount * 0.9;

    const formattedMonthlyPrice =
      monthlyTotal % 1 === 0
        ? `$${Math.round(monthlyTotal)}/month`
        : `$${monthlyTotal.toFixed(2)}/month`;

    // Format and display the price
    const formattedPrice = prepaidPrice % 1 === 0 
      ? `$${Math.round(prepaidPrice)}` 
      : `$${prepaidPrice.toFixed(2)}`;

    const monthlyPriceElement = document.querySelector(
      "[data-condensed-prepaid-monthly-price]"
    );
    const priceElement = document.querySelector("[data-condensed-prepaid-price]");
    const priceTextElement = document.querySelector("[data-condensed-prepaid-text]");

    if (monthlyPriceElement) {
      monthlyPriceElement.textContent = formattedMonthlyPrice;
    }
    
    if (priceElement) {
      priceElement.textContent = formattedPrice;
    }
    // Ensure the text is visible (it should already be shown in handleCommitmentLengthChange, but double-check)
    if (priceTextElement) {
      priceTextElement.classList.remove("display-none");
    }
    if (priceElement) {
      priceElement.classList.remove("display-none");
    }
  },
};

document.addEventListener("SubscriptionFunnel:QuizDataReady", () => {
  window.SubscriptionFunnel.CondensedQuizDataReady = true;
  const condensed = window.SubscriptionFunnel?.StepCondensed;
  if (condensed?.form) {
    condensed.syncFormFromQuizData();
    condensed.updateEmailSectionVisibility();
    condensed.initCondensedAffiliateProductLine();
    condensed.initializeGwpState();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.SubscriptionFunnel.StepCondensed.isCondensedMode()) {
    window.SubscriptionFunnel.StepCondensed.init();
  }
});

